<template>
    <div class="g-bottom index">
        <p class="m-copyright">Copyright 2002-今 南京奥派信息产业股份公司 <a href="https://beian.miit.gov.cn" target="_blank">苏ICP备12023604号-1</a></p>
    </div>
</template>

<script>
    export default {
        name: "app-footer"
    };
</script>

<style scoped>

</style>
